import { authRequests } from "@/api/(requests)/auth";
import { paymentRequests } from "@/api/(requests)/payment";

import * as actionTypes from "./actionTypes";
import { allowLoginPopUps } from "./patient";
import { hideLoader, showLoader } from "./loader";
import { profileFetchSuccess } from "./auth";

const updatePaymentProcessorSession = (sessionInfo) => ({
  payload: {
    ...sessionInfo,
  },
  type: actionTypes.UPDATE_PAYMENT_PROCESSOR_SESSION,
});

export const fetchPaymentProcessorSessionToken = ({
  addToken = true,
  captchaVerificationToken,
  dispatch,
  firstName,
  getToken = true,
  history,
  lastName,
  transactionAmount = 0.01,
  transactionType = "AUTHORIZATION",
  workflow,
}) => {
  return paymentRequests
    .getPaymentSessionToken({
      context: {
        exceptionConfig: {
          ActivityException: {
            errorCallback: async () => {
              if (workflow !== "MOBILE") {
                dispatch(showLoader());
                const profile = await authRequests.fetch_profile({
                  context: { showLoader: false },
                });

                dispatch(profileFetchSuccess(profile.user));
                dispatch(allowLoginPopUps());
                dispatch(hideLoader());
                history.replace("/app/home");
              }
            },
            preventToast: true,
          },
        },
      },
      data: {
        add_token: addToken,
        captcha_response_key: captchaVerificationToken,
        first_name: firstName,
        get_token: getToken,
        last_name: lastName,
        transaction_amount: transactionAmount,
        transaction_type: transactionType,
      },
    })
    .then((body) => {
      const { session_token } = body;

      dispatch(updatePaymentProcessorSession({ sessionToken: session_token }));

      return session_token;
    });
};
